import type { TranslationKey } from "../locales";
import type { Enums, Nullable } from "../types";

export function getFulfillmentTypeTranslationKey(
	fulfillmentType: Nullable<Enums<"serviceFulfillmentType">>,
): TranslationKey {
	switch (fulfillmentType) {
		case "internal":
			return "organization.data.internal_service";
		case "external":
			return "organization.data.external_service";
		default:
			return "general.unknown";
	}
}
